export const DOCUVERUS_ADMIN_ROLE = 'Docuverus Admin';

export const resolveSelectedSubscriberId = (identity: any, switchSubscriberObj: any) => {
  const isDocuverusAdmin = identity?.userrole === DOCUVERUS_ADMIN_ROLE;

  return isDocuverusAdmin
    ? switchSubscriberObj?.value || identity?.subscriberid
    : identity?.subscriberid || switchSubscriberObj?.value;
};
